import { createSlice } from '@reduxjs/toolkit'

export const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState: {
    showVehicle: false,
    showDriveOff: false,
    selectedVehicle: null,
    selectedVehicleHistory: [],
  },
  reducers: {
    setShowVehicle: (state, action) => {
      state.showVehicle = action.payload
    },
    setSelectedVehicle: (state, action) => { 
      state.selectedVehicle = action.payload
    },
    setSelectedVehicleHistory: (state, action) => { 
      state.selectedVehicleHistory = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setShowVehicle, setSelectedVehicle, setSelectedVehicleHistory} = vehicleSlice.actions
export const showVehicle = (state) => state.vehicle.showVehicle
export const selectedVehicle = (state) => state.vehicle.selectedVehicle
export const selectedVehicleHistory = (state) => state.vehicle.selectedVehicleHistory
export default vehicleSlice.reducer